import axios from "axios";

let fail = function (params) {

    const $page = $('.page-status');

};

export default fail;